const CityAPI = [
    { id: 1, title: "Adana", endpoint: "adana" },
    { id: 2, title: "Adıyaman", endpoint: "adiyaman" },
    { id: 3, title: "Afyonkarahisar", endpoint: "afyonkarahisar" },
    { id: 4, title: "Ağrı", endpoint: "agri" },
    { id: 5, title: "Amasya", endpoint: "amasya" },
    { id: 6, title: "Ankara", endpoint: "ankara" },
    { id: 7, title: "Antalya", endpoint: "antalya" },
    { id: 8, title: "Artvin", endpoint: "artvin" },
    { id: 9, title: "Aydın", endpoint: "aydin" },
    { id: 10, title: "Balıkesir", endpoint: "balikesir" },
    { id: 11, title: "Bilecik", endpoint: "bilecik" },
    { id: 12, title: "Bingöl", endpoint: "bingol" },
    { id: 13, title: "Bitlis", endpoint: "bitlis" },
    { id: 14, title: "Bolu", endpoint: "bolu" },
    { id: 15, title: "Burdur", endpoint: "burdur" },
    { id: 16, title: "Bursa", endpoint: "bursa" },
    { id: 17, title: "Çanakkale", endpoint: "canakkale" },
    { id: 18, title: "Çankırı", endpoint: "cankiri" },
    { id: 19, title: "Çorum", endpoint: "corum" },
    { id: 20, title: "Denizli", endpoint: "denizli" },
    { id: 21, title: "Diyarbakır", endpoint: "diyarbakir" },
    { id: 22, title: "Edirne", endpoint: "edirne" },
    { id: 23, title: "Elazığ", endpoint: "elazig" },
    { id: 24, title: "Erzincan", endpoint: "erzincan" },
    { id: 25, title: "Erzurum", endpoint: "erzurum" },
    { id: 26, title: "Eskişehir", endpoint: "eskisehir" },
    { id: 27, title: "Gaziantep", endpoint: "gaziantep" },
    { id: 28, title: "Giresun", endpoint: "giresun" },
    { id: 29, title: "Gümüşhane", endpoint: "gumushane" },
    { id: 30, title: "Hakkari", endpoint: "hakkari" },
    { id: 31, title: "Hatay", endpoint: "hatay" },
    { id: 32, title: "Isparta", endpoint: "isparta" },
    { id: 33, title: "Mersin", endpoint: "mersin" },
    { id: 34, title: "İstanbul", endpoint: "istanbul" },
    { id: 35, title: "İzmir", endpoint: "izmir" },
    { id: 36, title: "Kars", endpoint: "kars" },
    { id: 37, title: "Kastamonu", endpoint: "kastamonu" },
    { id: 38, title: "Kayseri", endpoint: "kayseri" },
    { id: 39, title: "Kırklareli", endpoint: "kirklareli" },
    { id: 40, title: "Kırşehir", endpoint: "kirsehir" },
    { id: 41, title: "Kocaeli", endpoint: "kocaeli" },
    { id: 42, title: "Konya", endpoint: "konya" },
    { id: 43, title: "Kütahya", endpoint: "kutahya" },
    { id: 44, title: "Malatya", endpoint: "malatya" },
    { id: 45, title: "Manisa", endpoint: "manisa" },
    { id: 46, title: "Kahramanmaraş", endpoint: "kahramanmaras" },
    { id: 47, title: "Mardin", endpoint: "mardin" },
    { id: 48, title: "Muğla", endpoint: "mugla" },
    { id: 49, title: "Muş", endpoint: "mus" },
    { id: 50, title: "Nevşehir", endpoint: "nevsehir" },
    { id: 51, title: "Niğde", endpoint: "nigde" },
    { id: 52, title: "Ordu", endpoint: "ordu" },
    { id: 53, title: "Rize", endpoint: "rize" },
    { id: 54, title: "Sakarya", endpoint: "sakarya" },
    { id: 55, title: "Samsun", endpoint: "samsun" },
    { id: 56, title: "Siirt", endpoint: "siirt" },
    { id: 57, title: "Sinop", endpoint: "sinop" },
    { id: 58, title: "Sivas", endpoint: "sivas" },
    { id: 59, title: "Tekirdağ", endpoint: "tekirdag" },
    { id: 60, title: "Tokat", endpoint: "tokat" },
    { id: 61, title: "Trabzon", endpoint: "trabzon" },
    { id: 62, title: "Tunceli", endpoint: "tunceli" },
    { id: 63, title: "Şanlıurfa", endpoint: "sanliurfa" },
    { id: 64, title: "Uşak", endpoint: "usak" },
    { id: 65, title: "Van", endpoint: "van" },
    { id: 66, title: "Yozgat", endpoint: "yozgat" },
    { id: 67, title: "Zonguldak", endpoint: "zonguldak" },
    { id: 68, title: "Aksaray", endpoint: "aksaray" },
    { id: 69, title: "Bayburt", endpoint: "bayburt" },
    { id: 70, title: "Karaman", endpoint: "karaman" },
    { id: 71, title: "Kırıkkale", endpoint: "kirikkale" },
    { id: 72, title: "Batman", endpoint: "batman" },
    { id: 73, title: "Şırnak", endpoint: "sirnak" },
    { id: 74, title: "Bartın", endpoint: "bartin" },
    { id: 75, title: "Ardahan", endpoint: "ardahan" },
    { id: 76, title: "Iğdır", endpoint: "igdir" },
    { id: 77, title: "Yalova", endpoint: "yalova" },
    { id: 78, title: "Karabük", endpoint: "karabuk" },
    { id: 79, title: "Kilis", endpoint: "kilis" },
    { id: 80, title: "Osmaniye", endpoint: "osmaniye" },
    { id: 81, title: "Düzce", endpoint: "duzce" }
];

export default CityAPI;
